import fetchPublishedSiteData from './fetch-published-site-data';

export default {
  fetchPublishedSiteData,
};
